/* Product page behaviour: gallery, colour swatches, bundle picker and the
   Shop Pay sync. Split out of the section so it can be deferred — inline it
   cost ~529 ms of parse/execute on the critical path.
   Liquid-derived values arrive via the #product-config JSON block. */
(function () {
  var cfgEl = document.getElementById("product-config");
  var variantsEl = document.getElementById("product-variants-json");
  if (!cfgEl || !variantsEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var variants = JSON.parse(variantsEl.textContent);
  var moneyFormat = cfg.moneyFormat;
  var colorPos = cfg.colorPos;
  var sizePos = cfg.sizePos;

  // Build colors and sizes lists (preserve product order)
  var colors = [];
  var sizes = [];
  variants.forEach(function (v) {
    var c = colorPos ? v["option" + colorPos] : null;
    var s = sizePos ? v["option" + sizePos] : null;
    if (c && colors.indexOf(c) === -1) colors.push(c);
    if (s && sizes.indexOf(s) === -1) sizes.push(s);
  });

  function colorHex(name) {
    var n = (name || "").toString().toLowerCase().trim();
    // Patterns multi-color gradient swatches (new naming: "X + Y" / "X + Y + Z")
    if (n === "gray + blue")
      return "linear-gradient(180deg,#9aa0a6 0%,#5dd0d6 100%)";
    if (n === "blue + pink")
      return "linear-gradient(135deg,#5dd0d6 0%,#e85a8d 100%)";
    if (n === "green + orange")
      return "linear-gradient(135deg,#cdee3a 0%,#f47a3a 100%)";
    if (n === "orange + blue")
      return "linear-gradient(135deg,#f5a04a 0%,#7ad3d3 100%)";
    if (n === "pink + purple")
      return "linear-gradient(135deg,#e83271 0%,#a23b9e 100%)";
    if (n === "pink + blue + yellow")
      return "linear-gradient(135deg,#e83271 30%,#5dd0d6 70%,#f4d24a 100%)";
    // Substring match for solid colors (handles "Peep Toe Socks Black", "Skin Color" etc.)
    if (n.indexOf("black") !== -1) return "#1a1a1a";
    if (n.indexOf("navy") !== -1) return "#1d3a64";
    if (n.indexOf("coffee") !== -1 || n.indexOf("brown") !== -1)
      return "#5a3927";
    if (
      n.indexOf("skin") !== -1 ||
      n.indexOf("beige") !== -1 ||
      n.indexOf("nude") !== -1
    )
      return "#e8c8a4";
    if (n.indexOf("blue") !== -1) return "#1d3a64";
    if (n.indexOf("gray") !== -1 || n.indexOf("grey") !== -1) return "#9aa0a6";
    if (n.indexOf("white") !== -1) return "#f3f3f3";
    if (n.indexOf("cream") !== -1) return "#fbf3e3";
    if (n.indexOf("pink") !== -1 || n.indexOf("rose") !== -1) return "#e8a4b8";
    if (n.indexOf("red") !== -1) return "#c0392b";
    if (n.indexOf("green") !== -1) return "#2c7a5e";
    if (n.indexOf("orange") !== -1) return "#e07a3a";
    if (n.indexOf("yellow") !== -1) return "#e0c54a";
    return "#cccccc";
  }

  function findVariant(colorVal, sizeVal) {
    return variants.find(function (v) {
      var okC = colorPos ? v["option" + colorPos] === colorVal : true;
      var okS = sizePos ? v["option" + sizePos] === sizeVal : true;
      return okC && okS;
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return (s || "").toString().replace(/"/g, "&quot;");
  }

  function buildRowHTML(idx) {
    // The native select stays in the DOM (visually hidden) and remains the single
    // source of truth, so add-to-cart, Shop Pay sync and the uniform-bundle check
    // keep reading .bogo-row__color exactly as before. The custom listbox below
    // only writes to it and fires a change event.
    var colorOpts = colors
      .map(function (c) {
        return '<option value="' + esc(c) + '">' + c + "</option>";
      })
      .join("");
    var swatchOpts = colors
      .map(function (c) {
        return (
          '<button type="button" role="option" class="bogo-opt" data-value="' +
          esc(c) +
          '">' +
          '<span class="bogo-opt__dot" style="background:' +
          colorHex(c) +
          '"></span>' +
          '<span class="bogo-opt__name">' +
          c +
          "</span>" +
          '<svg class="bogo-opt__tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
          "</button>"
        );
      })
      .join("");
    return (
      "" +
      '<div class="bogo-row" data-row-idx="' +
      idx +
      '">' +
      '<span class="bogo-row__thumb"></span>' +
      '<div class="bogo-swatch">' +
      '<select class="bogo-row__color" tabindex="-1" aria-hidden="true" aria-label="Color for pair ' +
      idx +
      '">' +
      colorOpts +
      "</select>" +
      '<button type="button" class="bogo-swatch__btn" aria-haspopup="listbox" aria-expanded="false" aria-label="Color for pair ' +
      idx +
      '">' +
      '<span class="bogo-row__dot"></span>' +
      '<span class="bogo-swatch__label"></span>' +
      '<svg class="bogo-swatch__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>' +
      "</button>" +
      '<div class="bogo-swatch__menu" role="listbox" hidden>' +
      swatchOpts +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }

  // colour -> gallery image id, taken from whichever variant of that colour has one
  //
  // У шаблона может быть своя галерея (унисекс делит товар с женской витриной,
  // поэтому подменить product.images там нельзя). В этом случае кадры не
  // привязаны к вариантам вовсе, и связь «цвет → кадр» берём из data-colour
  // самой миниатюры. Разметка — единственный источник правды в обоих режимах.
  var colorImageId = (function () {
    var map = {};
    var own = document.querySelectorAll(".gallery-thumb[data-colour]");
    if (own.length) {
      own.forEach(function (t) {
        var c = t.dataset.colour;
        if (c && !map[c]) map[c] = t.dataset.imgId;
      });
      return map;
    }
    variants.forEach(function (v) {
      var c = colorPos ? v["option" + colorPos] : null;
      if (c && !map[c] && v.featured_image && v.featured_image.id)
        map[c] = v.featured_image.id;
    });
    return map;
  })();

  // Show the picked colour in the main gallery straight away, so the shopper
  // sees what they just chose without hunting through the thumbnails.
  function showColorInGallery(colorValue) {
    var imgId = colorImageId[colorValue];
    if (!imgId) return;
    var thumb = document.querySelector(
      '.gallery-thumb[data-img-id="' + imgId + '"]',
    );
    if (!thumb || thumb.classList.contains("active")) return;
    thumb.click(); // vGallerySwitch handles the cross-fade and strip scrolling
  }

  // Show the actual product photo for the colour chosen on that row, so eight
  // identical dropdowns stop reading as a faceless wall.
  function refreshThumb(row) {
    var th = row.querySelector(".bogo-row__thumb");
    var sel = row.querySelector(".bogo-row__color");
    if (!th || !sel) return;
    var id = colorImageId[sel.value];
    var thumb =
      id &&
      document.querySelector('.gallery-thumb[data-img-id="' + id + '"] img');
    if (!thumb) return;
    // currentSrc пуст, пока браузер не загрузил картинку, а миниатюры галереи
    // ленивые — на первом заходе сюда попадал url(""), и он там оставался
    // навсегда: refreshThumb перезапускается только при смене цвета.
    // src отдаёт абсолютный адрес из атрибута сразу, до всякой загрузки.
    var url = thumb.currentSrc || thumb.src;
    if (url) th.style.backgroundImage = 'url("' + url + '")';
  }

  // Матрица размер × цвет неполная: большие размеры есть не у всех цветов, и
  // что-то из них ещё и кончилось. Без фильтра findVariant вернёт undefined и
  // покупатель получит «Please choose a size and color», хотя он выбрал и то,
  // и другое. Считаем по v.available, а не по факту существования варианта, —
  // распроданное сочетание всё равно не доедет до корзины.
  var stockBySize = (function () {
    var map = {};
    variants.forEach(function (v) {
      if (!v.available) return;
      var c = colorPos ? v["option" + colorPos] : "*";
      var s = sizePos ? v["option" + sizePos] : "*";
      (map[s] || (map[s] = {}))[c] = true;
    });
    return map;
  })();

  // ---- Единый размер на весь заказ ---------------------------------------
  // Раньше размер жил в каждой строке набора; теперь он один, наверху, и
  // ведущий: под него фильтруются цвета, а не наоборот.
  var sizeRow = document.getElementById("sizeRow");

  function currentSize() {
    if (!sizePos) return null;
    var on = sizeRow && sizeRow.querySelector('.sizepill[aria-checked="true"]');
    return on ? on.dataset.size : sizes[0];
  }

  function coloursForCurrentSize() {
    return stockBySize[currentSize()] || {};
  }

  // Цвет, недоступный в выбранном размере, гасим и в строках набора, и в
  // верхнем ряду кружков. Строку, стоящую на исчезнувшем цвете, переводим
  // на первый доступный — иначе корзина молча недосчитается пары.
  function syncColoursForSize() {
    var ok = coloursForCurrentSize();
    var firstOk = colors.filter(function (c) {
      return ok[c];
    })[0];

    // Недоступный цвет убираем из ряда совсем, а не гасим: погашенный кружок
    // всё равно читается как выбираемый, по нему жмут и ничего не происходит.
    var shown = 0;
    var live = null;
    document.querySelectorAll(".cswatch").forEach(function (b) {
      var good = !!ok[b.dataset.colour];
      b.hidden = !good;
      b.disabled = !good;
      if (!good) {
        b.removeAttribute("aria-current");
      } else {
        shown++;
        if (!live) live = b;
      }
    });
    var count = document.getElementById("colourCount");
    if (count) count.innerHTML = "&middot; " + shown + " available";
    // Подсветка могла остаться на исчезнувшем цвете — переносим на первый живой.
    var swatchRow = document.getElementById("colourRow");
    if (
      swatchRow &&
      live &&
      !swatchRow.querySelector('.cswatch[aria-current="true"]')
    ) {
      live.setAttribute("aria-current", "true");
      var nameEl = document.getElementById("colourName");
      if (nameEl) nameEl.textContent = live.dataset.colour;
    }

    document.querySelectorAll(".bogo-row").forEach(function (row) {
      var sel = row.querySelector(".bogo-row__color");
      if (!sel) return;
      [].slice.call(sel.options).forEach(function (opt) {
        var good = !!ok[opt.value];
        opt.disabled = !good;
        opt.hidden = !good;
      });
      row.querySelectorAll(".bogo-opt").forEach(function (o) {
        var good = !!ok[o.dataset.value];
        o.hidden = !good;
        o.disabled = !good;
      });
      if (firstOk && !ok[sel.value]) {
        sel.value = firstOk;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  if (sizeRow) {
    var sizeName = document.getElementById("sizeName");
    sizeRow.addEventListener("click", function (e) {
      var pill = e.target.closest(".sizepill");
      if (!pill || pill.disabled) return;
      sizeRow.querySelectorAll(".sizepill").forEach(function (p) {
        p.setAttribute("aria-checked", p === pill ? "true" : "false");
      });
      if (sizeName) sizeName.textContent = pill.dataset.size;
      syncColoursForSize();
      syncShopPay(document.querySelector(".bogo-card--selected"));
    });
  }

  function refreshDot(row) {
    var dot = row.querySelector(".bogo-row__dot");
    var sel = row.querySelector(".bogo-row__color");
    if (!sel) return;
    refreshThumb(row);
    if (dot) dot.style.background = colorHex(sel.value);
    var label = row.querySelector(".bogo-swatch__label");
    if (label) label.textContent = sel.value;
    row.querySelectorAll(".bogo-opt").forEach(function (o) {
      o.setAttribute(
        "aria-selected",
        o.dataset.value === sel.value ? "true" : "false",
      );
    });
  }

  function closeAllSwatches(except) {
    document.querySelectorAll(".bogo-swatch.is-open").forEach(function (s) {
      if (s === except) return;
      s.classList.remove("is-open");
      s.querySelector(".bogo-swatch__menu").hidden = true;
      s.querySelector(".bogo-swatch__btn").setAttribute(
        "aria-expanded",
        "false",
      );
    });
  }

  function wireSwatch(row) {
    var wrap = row.querySelector(".bogo-swatch");
    if (!wrap) return;
    var btn = wrap.querySelector(".bogo-swatch__btn");
    var menu = wrap.querySelector(".bogo-swatch__menu");
    var sel = row.querySelector(".bogo-row__color");

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var willOpen = !wrap.classList.contains("is-open");
      closeAllSwatches(wrap);
      wrap.classList.toggle("is-open", willOpen);
      menu.hidden = !willOpen;
      btn.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });

    menu.addEventListener("click", function (e) {
      var opt = e.target.closest(".bogo-opt");
      if (!opt) return;
      e.stopPropagation();
      sel.value = opt.dataset.value;
      sel.dispatchEvent(new Event("change", { bubbles: true }));
      closeAllSwatches();
    });

    wrap.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeAllSwatches();
        btn.focus();
      }
    });
  }

  document.addEventListener("click", function () {
    closeAllSwatches();
  });

  // Colour swatches above the bundle: one tap sets every pair and the gallery.
  (function () {
    var row = document.getElementById("colourRow");
    if (!row) return;
    var label = document.getElementById("colourName");
    row.querySelectorAll(".cswatch").forEach(function (b) {
      b.style.background = colorHex(b.dataset.colour);
    });
    row.addEventListener("click", function (e) {
      var b = e.target.closest(".cswatch");
      if (!b) return;
      row.querySelectorAll(".cswatch").forEach(function (x) {
        x.removeAttribute("aria-current");
      });
      b.setAttribute("aria-current", "true");
      if (label) label.textContent = b.dataset.colour;
      var card = document.querySelector(".bogo-card--selected");
      if (card) {
        card.querySelectorAll(".bogo-row__color").forEach(function (sel) {
          sel.value = b.dataset.colour;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
      showColorInGallery(b.dataset.colour);
    });
  })();

  function renderRows(card) {
    var box = card.querySelector("[data-rows]");
    if (!box) return;
    var total = parseInt(card.dataset.total, 10) || 1;
    if (total <= 1) {
      // 1 Pair: still need 1 row so user can pick size+color
      total = 1;
    }
    box.innerHTML =
      '<div class="bogo-card__rows-label">' +
      (total > 1 ? "Color for each pair" : "Color") +
      "</div>" +
      Array.from({ length: total }, function (_, i) {
        return buildRowHTML(i + 1);
      }).join("");
    box.querySelectorAll(".bogo-row").forEach(function (row) {
      wireSwatch(row);
      refreshDot(row);
      row
        .querySelector(".bogo-row__color")
        .addEventListener("change", function () {
          refreshDot(row);
          showColorInGallery(this.value);
          syncShopPay(document.querySelector(".bogo-card--selected"));
        });
    });
    // Строки создаются заново при каждой смене набора, поэтому фильтр цветов
    // под выбранный размер нужно прогнать здесь, а не только по клику на плашку.
    syncColoursForSize();
  }

  // Keep the native Shop Pay / dynamic-checkout button in sync with the chosen
  // bundle: it buys (first selected variant) × (bundle total qty). The Buy-X-Get-Y
  // automatic discount then applies in checkout, exactly like the cart flow.
  function syncShopPay(card) {
    var wrap = document.getElementById("shopPayWrap");
    var vEl = document.getElementById("shopPayVariant");
    var qEl = document.getElementById("shopPayQty");
    if (!wrap || !vEl || !qEl || !card) return;

    var rows = Array.prototype.slice.call(card.querySelectorAll(".bogo-row"));
    var total = parseInt(card.getAttribute("data-total"), 10) || 1;

    // Express Shop Pay can only carry ONE variant × qty. Размер теперь общий,
    // поэтому проверять надо только цвет: разные цвета в наборе схлопнулись бы
    // в один вариант. В этом случае прячем кнопку, и покупатель уходит через
    // Add to Cart, который отправляет настоящий items[].
    var first = rows[0];
    var uniform = rows.length > 0;
    if (first) {
      var c0 = first.querySelector(".bogo-row__color").value;
      var s0 = currentSize();
      for (var i = 1; i < rows.length; i++) {
        if (rows[i].querySelector(".bogo-row__color").value !== c0) {
          uniform = false;
          break;
        }
      }
      var v = findVariant(c0, s0);
      if (uniform && v) {
        vEl.value = v.id;
        qEl.value = total;
        wrap.hidden = false;
      } else {
        wrap.hidden = true;
      }
    } else {
      wrap.hidden = true;
    }
  }

  function selectCard(card) {
    document.querySelectorAll(".bogo-card").forEach(function (c) {
      c.classList.remove("bogo-card--selected");
      var box = c.querySelector("[data-rows]");
      if (box) box.innerHTML = "";
    });
    card.classList.add("bogo-card--selected");
    var radio = card.querySelector("input[type=radio]");
    if (radio) radio.checked = true;
    renderRows(card);
    updateAtcLabel(card);
    syncShopPay(card);
  }

  function updateAtcLabel(card) {
    var nowEl = card.querySelector(".bogo-card__now");
    var atcPrice = document.getElementById("atcPrice");
    var stickyPrice = document.getElementById("stickyPrice");
    var stickyQty = document.getElementById("stickyQty");
    var label = nowEl ? nowEl.textContent : "";
    if (atcPrice) atcPrice.textContent = label;
    if (stickyPrice) stickyPrice.textContent = label;
    if (stickyQty) {
      var paid = parseInt(card.getAttribute("data-paid"), 10) || 1;
      var total = parseInt(card.getAttribute("data-total"), 10) || paid;
      var free = total - paid;
      var qtyText = total + " pair" + (total === 1 ? "" : "s");
      if (free > 0) qtyText += " · Buy " + paid + " Get " + free + " Free";
      stickyQty.textContent = qtyText;
    }
  }

  document.querySelectorAll(".bogo-card").forEach(function (card) {
    card.addEventListener("click", function (e) {
      // Don't re-select if clicking inside a size select or the colour listbox —
      // selectCard() re-renders every row and would wipe the shopper's choices.
      if (e.target.tagName === "SELECT" || e.target.tagName === "OPTION")
        return;
      if (e.target.closest(".bogo-swatch")) return;
      selectCard(card);
    });
  });

  // Init: select default (Best Seller — pre-marked)
  var initial =
    document.querySelector(".bogo-card--selected") ||
    document.querySelector(".bogo-card");
  if (initial) selectCard(initial);

  // ---- GA4 add_to_cart -----------------------------------------------------
  // Кнопка «Add to Cart» не перезагружает страницу — товар уезжает через
  // fetch. Поэтому ни один автоматический триггер GTM (клик, отправка формы)
  // не годится: он сработает и тогда, когда добавление провалилось. Событие
  // шлём сами и только после ответа сервера.
  //
  // value — та сумма, которую покупатель реально заплатит за набор (для 3+3
  // это $66, а не 6×$28): скидка применяется автоматически, и оптимизация
  // Google Ads должна видеть настоящие деньги. Берём её из подписи карточки —
  // цены наборов фиксированные и умножением не считаются.
  function bundleValue(card) {
    var el = card && card.querySelector(".bogo-card__now");
    if (!el) return null;
    var n = parseFloat(
      el.textContent.replace(/[^\d.,]/g, "").replace(/,/g, ""),
    );
    return isNaN(n) ? null : n;
  }

  // Собственная воронка Shopify не видит наши добавления: блок набора шлёт
  // товары через fetch на /cart/add.js, а пиксель ловит только отправку формы
  // и XHR. Из-за этого «Added to cart» в отчёте занижен, и в воронке чекаутов
  // оказывалось больше, чем добавлений. Досылаем событие сами.
  //
  // Метод недокументированный, Shopify его может убрать — поэтому всё в try,
  // и от него не зависит ни покупка, ни наше событие для Google.
  function pingShopifyAnalytics(items) {
    try {
      var lib = window.ShopifyAnalytics && window.ShopifyAnalytics.lib;
      if (!lib || typeof lib.track !== "function") return;
      var meta =
        (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
      items.forEach(function (it) {
        var v = variants.filter(function (x) {
          return String(x.id) === String(it.id);
        })[0];
        if (!v) return;
        lib.track("Added Product", {
          variantId: v.id,
          productId: cfg.productId,
          name: cfg.productTitle,
          variant: v.title,
          price: (v.price / 100).toFixed(2),
          sku: v.sku || "",
          quantity: it.quantity,
          currency: cfg.currency || "USD",
          handle: meta.product ? meta.product.handle : undefined,
          nonInteraction: true,
        });
      });
    } catch (e) {
      /* аналитика не должна ломать покупку */
    }
  }

  function trackAddToCart(card, items) {
    pingShopifyAnalytics(items);

    try {
      // Одинаковые пары схлопываем в одну позицию с quantity — GA4 ждёт
      // список товаров, а не список строк интерфейса.
      var byId = {};
      items.forEach(function (it) {
        byId[it.id] = (byId[it.id] || 0) + it.quantity;
      });
      var gaItems = Object.keys(byId).map(function (id) {
        var v = variants.filter(function (x) {
          return String(x.id) === String(id);
        })[0];
        return {
          item_id: v && v.sku ? v.sku : String(id),
          item_name: cfg.productTitle,
          item_variant: v ? v.title : undefined,
          item_brand: "Velora",
          item_category: cfg.productType || undefined,
          price: v ? v.price / 100 : undefined,
          quantity: byId[id],
        };
      });
      var value = bundleValue(card);
      window.dataLayer = window.dataLayer || [];
      // Обнуление перед push — рекомендация Google: без него объект ecommerce
      // от прошлого события склеивается с новым.
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: cfg.currency || "USD",
          value: value,
          items: gaItems,
        },
      });
    } catch (e) {
      /* аналитика не должна ломать покупку */
    }
  }

  // Form submit → POST items[] to /cart/add.js
  var form = document.getElementById("bundle-form");
  var atcBtn = document.getElementById("mainAtcBtn");
  // Набор считает приложение (Kaching): оно само вешается на кнопку внутри
  // формы и добавляет свой комплект. Наш обработчик в этом режиме не вешаем —
  // иначе один клик даст два добавления. Всё остальное поведение страницы
  // (галерея, свотчи, липкая цена) продолжает работать как прежде.
  //
  // Но и совсем без обработчика нельзя: у формы теперь есть action и скрытое
  // поле id (они нужны приложению, чтобы вообще найти кнопку), поэтому клик
  // уходит нативной отправкой — Shopify добавляет одну случайную пару и
  // выкидывает покупателя на /cart. Гасим отправку: если приложение свой
  // обработчик навесило, оно отработает само, а нативный переход не случится.
  // Приложение не перехватывает клик — оно лишь заполняет форму скрытыми
  // полями (id, quantity, properties[__kaching_bundles]), а отправляет её
  // браузер. Нативная отправка уводит на /cart мимо нашего дровера, поэтому
  // отправляем ту же форму сами и открываем корзину на месте.
  if (form && cfg.appBundle) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (atcBtn) atcBtn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: { "X-Requested-With": "XMLHttpRequest" },
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function () {
          if (window.VeloraCart && window.VeloraCart.open) {
            window.VeloraCart.open();
          } else {
            window.location = "/cart";
          }
        })
        .catch(function () {
          // Не оставляем покупателя без результата: если запрос не прошёл,
          // отправляем форму как обычно — набор всё равно попадёт в корзину.
          form.submit();
        })
        .then(function () {
          if (atcBtn) atcBtn.disabled = false;
        });
    });
  }
  if (form && !cfg.appBundle) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var card = document.querySelector(".bogo-card--selected");
      if (!card) return;
      var rows = card.querySelectorAll(".bogo-row");
      var size = currentSize();
      var items = [];
      var ok = true;
      rows.forEach(function (row) {
        var color = row.querySelector(".bogo-row__color").value;
        var v = findVariant(color, size);
        if (!v) {
          ok = false;
          return;
        }
        items.push({ id: v.id, quantity: 1 });
      });
      if (!ok || !items.length) {
        alert("Please choose a size and a colour for every pair.");
        return;
      }
      atcBtn.disabled = true;
      var origLabel = atcBtn.innerHTML;
      atcBtn.innerHTML = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          return r.json().then(function (j) {
            return { ok: r.ok, j: j };
          });
        })
        .then(function (res) {
          if (!res.ok)
            throw new Error(
              res.j && res.j.description
                ? res.j.description
                : "Add to cart failed",
            );
          atcBtn.disabled = false;
          atcBtn.innerHTML = origLabel;
          trackAddToCart(card, items);
          if (window.VeloraCart) {
            window.VeloraCart.open();
          } else {
            window.location.href = "/cart";
          }
        })
        .catch(function (err) {
          alert(err.message || "Add to cart failed");
          atcBtn.disabled = false;
          atcBtn.innerHTML = origLabel;
        });
    });
  }

  // Size chart modal
  var sizeModal = document.getElementById("sizeModal");
  var sizeOpen = document.getElementById("openSizeChart");
  // Блокировка прокрутки. `overflow:hidden` на <body> здесь не работает:
  // у <html> стоит overflow-x: clip, и наследование overflow на вьюпорт
  // отключается. Ставим overflow прямо на <html> — он и есть контейнер
  // прокрутки. Позиция при этом никуда не девается, восстанавливать нечего.
  var sizePrevOverflow = "";
  function lockPage() {
    sizePrevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
  }
  function unlockPage() {
    document.documentElement.style.overflow = sizePrevOverflow;
  }
  function openSize() {
    if (!sizeModal || !sizeModal.hidden) return;
    markCurrentSize();
    sizeModal.hidden = false;
    lockPage();
    var c = sizeModal.querySelector(".size-modal__close");
    // preventScroll обязателен: фокус без него подкручивает страницу к элементу,
    // и позиция за модалкой уезжает.
    if (c) c.focus({ preventScroll: true });
  }
  function closeSize() {
    if (!sizeModal || sizeModal.hidden) return;
    sizeModal.hidden = true;
    unlockPage();
    if (sizeOpen) sizeOpen.focus({ preventScroll: true });
  }
  // Подсвечиваем строку того размера, который покупатель уже выбрал —
  // чтобы не искать себя в таблице глазами.
  function markCurrentSize() {
    if (!sizeModal) return;
    var val = currentSize();
    sizeModal.querySelectorAll("tbody tr").forEach(function (tr) {
      tr.classList.toggle("is-current", !!val && tr.dataset.size === val);
    });
  }
  // Гид размеров показывается картинкой, а на телефоне шрифт в ней мелкий.
  // По касанию разворачиваем её поверх модалки во весь экран — отдельный
  // слой, а не галерейный лайтбокс: тот листает миниатюры товара.
  var chartBtn = document.getElementById("sizeChartZoom");
  if (chartBtn) {
    var chartImg = chartBtn.querySelector(".size-modal__chart");
    chartBtn.addEventListener("click", function () {
      var on = chartBtn.classList.toggle("is-zoomed");
      chartBtn.setAttribute(
        "aria-label",
        on
          ? "Close the full screen size chart"
          : "Open the size chart full screen",
      );
      if (on && chartImg && chartImg.dataset.full)
        chartImg.src = chartImg.dataset.full;
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && chartBtn.classList.contains("is-zoomed")) {
        e.stopPropagation();
        chartBtn.classList.remove("is-zoomed");
      }
    });
  }

  if (sizeOpen) sizeOpen.addEventListener("click", openSize);
  if (sizeModal) {
    sizeModal.querySelectorAll("[data-close]").forEach(function (el) {
      el.addEventListener("click", closeSize);
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && sizeModal && !sizeModal.hidden) closeSize();
  });

  window.vGallerySwitch = function (thumb, src) {
    document.querySelectorAll(".gallery-thumb").forEach(function (t) {
      t.classList.remove("active");
    });
    thumb.classList.add("active");

    // Glide the thumbnail strip so the active one is centred. Done by hand on
    // the strip's own scrollLeft rather than scrollIntoView — even with
    // block:'nearest' the browser still scrolls the page vertically when the
    // strip isn't fully in view, which yanks the shopper away from the colour
    // swatches they just clicked.
    var strip = thumb.closest(".gallery-thumbs");
    if (strip && strip.scrollWidth > strip.clientWidth) {
      var target =
        thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
      var max = strip.scrollWidth - strip.clientWidth;
      target = Math.max(0, Math.min(target, max));
      if (strip.scrollTo) {
        strip.scrollTo({ left: target, behavior: "smooth" });
      } else {
        strip.scrollLeft = target;
      }
    }

    var main = document.getElementById("mainImg");
    if (!main || main.dataset.current === src) return;
    main.dataset.current = src;

    var swap = function () {
      // srcset wins over src, so it must be cleared before swapping — otherwise
      // the browser keeps painting the original featured image.
      main.removeAttribute("srcset");
      main.removeAttribute("sizes");
      main.src = src;
      requestAnimationFrame(function () {
        main.classList.remove("is-fading");
      });
    };

    if (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      swap();
      return;
    }

    // Decode the next image before fading, so the cross-fade never lands on an
    // empty frame while the file is still downloading.
    var next = new Image();
    var done = false;
    var run = function () {
      if (done) return;
      done = true;
      main.classList.add("is-fading");
      setTimeout(swap, 180);
    };
    next.onload = run;
    next.onerror = run;
    setTimeout(run, 600); // don't stall on a slow connection
    next.src = src;
  };
  window.vAccordionToggle = function (btn) {
    btn.closest(".accordion-item").classList.toggle("open");
  };

  // Sticky observer — only appear once user scrolls past the entire product top section
  var stickyAtc = document.getElementById("stickyAtc");
  var productMain = document.querySelector(".product-main");
  if (stickyAtc && productMain) {
    var updateSticky = function () {
      var rect = productMain.getBoundingClientRect();
      // Show only after the entire .product-main has scrolled above the viewport
      stickyAtc.classList.toggle("visible", rect.bottom < 0);
    };
    window.addEventListener("scroll", updateSticky, { passive: true });
    window.addEventListener("resize", updateSticky);
    updateSticky();
  }
})();

// Move "Built Different" features below the social-proof section on every
// breakpoint, so "240,000+ Women" comes first and the buy column stays short.
// Runs on DOMContentLoaded because social-proof sits later in the document.
(function () {
  function init() {
    var feats = document.querySelector(".prod-features-inline");
    if (!feats) return;
    var spRoot = document.querySelector(".social-proof");
    var sp = spRoot ? spRoot.closest(".shopify-section") || spRoot : null;
    if (!sp) return;
    sp.after(feats);
    feats.classList.add("pfi--moved");
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Star row jumps to the Loox widget. Loox mounts late, so fall back to the
  // app block wrapper and retry briefly if it hasn't rendered on first click.
  (function () {
    var trigger = document.getElementById("ratingJump");
    if (!trigger) return;
    function target() {
      return (
        document.getElementById("looxReviews") ||
        document.querySelector('[id*="loox_reviews"], .loox-widget')
      );
    }
    function jumpTo(el, smooth) {
      var y = el.getBoundingClientRect().top + window.pageYOffset - 70;
      window.scrollTo({ top: y, behavior: smooth ? "smooth" : "auto" });
    }
    trigger.addEventListener("click", function () {
      var tries = 0;
      (function go() {
        var el = target();
        if (!el) {
          if (tries++ < 12) setTimeout(go, 250);
          return;
        }
        jumpTo(el, true);
        // The widget keeps growing as its reviews load, so the anchor drifts
        // mid-scroll. Re-check a couple of times and correct if we overshot.
        [700, 1400, 2200].forEach(function (delay) {
          setTimeout(function () {
            var e = target();
            if (!e) return;
            var off = e.getBoundingClientRect().top - 70;
            if (Math.abs(off) > 120) jumpTo(e, true);
          }, delay);
        });
      })();
    });
  })();
})();

/* Свайп по главной фотографии на телефоне.
   Переключение галереи целиком живёт в vGallerySwitch — он же красит
   активную миниатюру, подкручивает ленту и делает кросс-фейд. Поэтому свайп
   не трогает картинку напрямую, а кликает по соседней миниатюре: вся логика
   остаётся в одном месте, и выбор цвета (product-bundle делает thumb.click())
   продолжает работать так же.
   Слушатели пассивные и preventDefault не зовут — вертикальная прокрутка
   страницы во время диагонального движения не ломается. Направление
   определяем по первым 10px и дальше не пересматриваем, иначе жест
   «наискосок» дёргает галерею при попытке проскроллить. */
(function () {
  var main = document.querySelector(".gallery-main");
  if (!main) return;

  var startX = 0,
    startY = 0,
    tracking = false,
    decided = false,
    horizontal = false;

  var MIN_SWIPE = 45; // короче — это тап или дрожь руки
  var DECIDE_AT = 10;

  function step(dir) {
    var list = document.querySelectorAll(".gallery-thumb");
    if (list.length < 2) return;
    var i = -1;
    for (var k = 0; k < list.length; k++) {
      if (list[k].classList.contains("active")) {
        i = k;
        break;
      }
    }
    if (i < 0) i = 0;
    var next = i + dir;
    if (next < 0 || next >= list.length) return; // на краях просто упираемся
    list[next].click();
  }

  main.addEventListener(
    "touchstart",
    function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
      decided = false;
      horizontal = false;
    },
    { passive: true },
  );

  main.addEventListener(
    "touchmove",
    function (e) {
      if (!tracking || decided) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > DECIDE_AT || Math.abs(dy) > DECIDE_AT) {
        decided = true;
        horizontal = Math.abs(dx) > Math.abs(dy);
      }
    },
    { passive: true },
  );

  main.addEventListener(
    "touchend",
    function (e) {
      if (!tracking) return;
      tracking = false;
      if (!horizontal) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < MIN_SWIPE) return;
      // Свайп на телефоне завершается синтетическим click — помечаем жест,
      // иначе следом откроется полноэкранный просмотр.
      main.dataset.swiping = "1";
      step(dx < 0 ? 1 : -1);
    },
    { passive: true },
  );

  main.addEventListener(
    "touchcancel",
    function () {
      tracking = false;
    },
    { passive: true },
  );
})();

/* Полноэкранный просмотр главной фотографии.
   Источник кадров — те же миниатюры (data-full), поэтому список всегда
   совпадает с галереей, а выбор цвета, который переключает миниатюры,
   не рассинхронизирует лайтбокс. При закрытии переносим выбранный кадр
   в саму галерею: человек листал в полный экран и ожидает увидеть там же
   то, на чём остановился. */
(function () {
  var box = document.getElementById("galleryLightbox");
  var main = document.querySelector(".gallery-main");
  if (!box || !main) return;

  var img = document.getElementById("lightboxImg");
  var counter = document.getElementById("lightboxCounter");
  var idx = 0;
  var lastFocus = null;

  function thumbs() {
    return [].slice.call(document.querySelectorAll(".gallery-thumb"));
  }
  function activeIndex() {
    var list = thumbs();
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains("active")) return i;
    }
    return 0;
  }
  function show(i) {
    var list = thumbs();
    if (!list.length) return;
    idx = (i + list.length) % list.length; // по кругу — так ждут от лайтбокса
    var t = list[idx];
    img.src = t.dataset.full || t.querySelector("img").src;
    img.alt = t.dataset.alt || "";
    if (counter) counter.textContent = idx + 1 + " / " + list.length;
  }
  function open() {
    lastFocus = document.activeElement;
    show(activeIndex());
    box.hidden = false;
    document.body.classList.add("lightbox-open");
    requestAnimationFrame(function () {
      box.classList.add("is-open");
    });
    var close = document.getElementById("lightboxClose");
    if (close) close.focus();
  }
  function close() {
    box.classList.remove("is-open");
    document.body.classList.remove("lightbox-open");
    var list = thumbs();
    if (list[idx] && !list[idx].classList.contains("active")) list[idx].click();
    setTimeout(function () {
      box.hidden = true;
      img.removeAttribute("src");
    }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  main.addEventListener("click", function (e) {
    // Свайп заканчивается кликом — не открываем окно по случайному жесту.
    if (main.dataset.swiping === "1") {
      main.dataset.swiping = "";
      return;
    }
    e.preventDefault();
    open();
  });

  var prev = document.getElementById("lightboxPrev");
  var next = document.getElementById("lightboxNext");
  if (prev)
    prev.addEventListener("click", function (e) {
      e.stopPropagation();
      show(idx - 1);
    });
  if (next)
    next.addEventListener("click", function (e) {
      e.stopPropagation();
      show(idx + 1);
    });
  var closeBtn = document.getElementById("lightboxClose");
  if (closeBtn) closeBtn.addEventListener("click", close);

  // Клик мимо картинки закрывает — привычное поведение для такого окна.
  box.addEventListener("click", function (e) {
    if (e.target === box) close();
  });

  document.addEventListener("keydown", function (e) {
    if (box.hidden) return;
    if (e.key === "Escape") close();
    else if (e.key === "ArrowRight") show(idx + 1);
    else if (e.key === "ArrowLeft") show(idx - 1);
  });

  // Свайп внутри окна — тем же правилом, что и в галерее.
  var sx = 0,
    sy = 0,
    track = false,
    decided = false,
    horiz = false;
  box.addEventListener(
    "touchstart",
    function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      track = true;
      decided = false;
      horiz = false;
    },
    { passive: true },
  );
  box.addEventListener(
    "touchmove",
    function (e) {
      if (!track || decided) return;
      var dx = e.touches[0].clientX - sx,
        dy = e.touches[0].clientY - sy;
      if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
        decided = true;
        horiz = Math.abs(dx) > Math.abs(dy);
      }
    },
    { passive: true },
  );
  box.addEventListener(
    "touchend",
    function (e) {
      if (!track) return;
      track = false;
      if (!horiz) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) < 45) return;
      show(dx < 0 ? idx + 1 : idx - 1);
    },
    { passive: true },
  );
})();

/* Ленивый автоплей для всех роликов страницы.
   Такой же наблюдатель есть внутри секции соцпруфа, но её инлайновый скрипт
   выполняется до того, как ниже по документу появятся блоки image-text —
   их видео он не видит. Этот файл подключён с defer, то есть стартует после
   разбора всего DOM, поэтому ловит и то, и другое. Повторный play() по уже
   играющему видео безвреден. */
(function () {
  var vids = document.querySelectorAll("video[data-lazy-autoplay]");
  if (!vids.length) return;
  if (!("IntersectionObserver" in window)) {
    [].forEach.call(vids, function (v) {
      v.play().catch(function () {});
    });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.play().catch(function () {});
        io.unobserve(e.target);
      });
    },
    { rootMargin: "300px 0px" },
  );
  [].forEach.call(vids, function (v) {
    io.observe(v);
  });
})();
